import React, {useEffect, useState} from 'react'
import {DataGrid} from "@mui/x-data-grid";
import {CustomToolbar} from '../util/common';
import {getData} from "../util/__fetch";
import {Grid} from "@mui/material";

const orderColumns = [
  {field: 'broker', headerName: 'Broker', width: 70, type: 'string'},
  {field: 'tradingsymbol', headerName: 'Symbol', width: 210, type: 'string'},
  {field: 'ordertype', headerName: 'Order Type', width: 100, type: 'string'},
  {field: 'transactiontype', headerName: 'Action', width: 60},
  {field: 'status', headerName: 'Status', width: 100},
  {field: 'quantity', headerName: 'Quantity', width: 70},
  {field: 'averageprice', headerName: 'Avg Price', width: 100},
  {field: 'triggerprice', headerName: 'Trigger Price', width: 100},
  {field: 'exchtime', headerName: 'Traded On', width: 180},
  {field: 'orderid', headerName: 'Order Id', width: 150},
  {field: 'ordertag', headerName: 'Tag', width: 140},
  {field: 'text', headerName: 'Text', width: 600},
];

const OrderBook = ({user, userId}) => {
  const [orderRows, setOrderRows] = useState([]);
  const [allOrders, setAllOrders] = useState([]);

  useEffect(() => {
    getData(`/algo-trading/api/demat/order-book/users/${userId}`, user, setAllOrders, (() => {
    }), (() => {
    }))
      .then((res) => {
      })
  }, [user, userId]);
  useEffect(() => {
    setOrderRows(allOrders?.filter((order) => order?.exchange === 'NFO' || order?.exchange === 'BFO'))
  }, [allOrders])

  return (
    <Grid item>
      <DataGrid
        getRowId={(row) => row?.orderid}
        rows={orderRows}
        columns={orderColumns}
        density={"compact"}
        autoHeight={true}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 50
            }
          }
        }}
        slots={{
          toolbar: () => CustomToolbar('Order Book'),
        }}
        sx={{bgcolor: 'white'}}
      />
    </Grid>
  )
}

export default OrderBook